import React from 'react';
import OnXMarkdown from './OnXMarkdown';
import OnXActionButtons from './OnXActionButtons';
import { ONX_AVATAR } from './OnXHeader';

/** Un message : utilisateur a droite (texte brut), OnX a gauche (markdown + avatar). */
const OnXMessageBubble = ({ message }) => {
  if (message?.role === 'user') {
    return (
      <div className="flex justify-end mb-4">
        <div className="max-w-[70%] bg-primary text-primary-foreground rounded-2xl rounded-br-sm px-4 py-2.5">
          <p className="text-sm leading-relaxed whitespace-pre-wrap break-words">{message?.content}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-start gap-2.5 mb-4">
      <img
        src={ONX_AVATAR}
        alt=""
        aria-hidden="true"
        draggable={false}
        className="w-8 h-8 rounded-full object-cover flex-shrink-0 select-none"
      />
      <div className="max-w-[80%] min-w-0">
        <div className="bg-muted rounded-2xl rounded-bl-sm px-4 py-2.5">
          <OnXMarkdown content={message?.content} />
        </div>
        <OnXActionButtons actions={message?.actions} />
      </div>
    </div>
  );
};

export default OnXMessageBubble;
